import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/NodeDndManualSortButton/NodeDndManualSortButton.styled.ts",
    _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { Button } from '@gmini/ui-kit/lib/Button/Button.styled';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var NodeDndManualSortButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 20px;\n  width: 20px;\n  background: inherit;\n  ", "\n  ", "\n\n  path {\n    ", "\n  }\n\n  &:hover {\n    ", "\n  }\n"])), function (props) {
  return !props.show && 'opacity: 0;';
}, function (props) {
  return !props.disabled && props.active && 'background: rgba(0, 10, 87, 0.07);';
}, function (props) {
  return !props.disabled && 'fill: #A2A3B7;';
}, function (props) {
  return !props.disabled && 'background: rgba(0, 10, 87, 0.07);';
});
export var IconWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 10px;\n  min-width: 10px;\n  height: 14px;\n  min-height: 14px;\n\n  & > svg {\n    width: 100%;\n  }\n"])));